import { LogtoProvider as SdkProvider, type LogtoConfig } from '@logto/react';
import type { PropsWithChildren } from 'react';
import { getConfig } from '../config';

export function LogtoProvider({ children }: PropsWithChildren) {
  const cfg = getConfig();
  const logto: LogtoConfig = {
    endpoint: cfg.logtoEndpoint,
    appId: cfg.logtoAppId,
    resources: [cfg.apiUrl]
  };
  return <SdkProvider config={logto}>{children}</SdkProvider>;
}
